import apiServices from 'config/apiServiceApiGateway'
import type {
  BannedKeywordPaginationDirectionType,
  BannedKeywordType,
} from 'features/Account/@types/bannedKeyword'

const { Get, Post, Put, Delete } = apiServices

const BANNED_KEYWORD_URL = '/messaging/internal/v1/banned-keyword'

export type GetBannedKeywordListResponseType = {
  data: { data: BannedKeywordType }[]
  pagination: {
    previous_cursor: string
    next_cursor: string
    next_page_exist: boolean
    previous_page_exist: boolean
  }
}

export type GetBannedKeywordListRequestType = {
  params: {
    limit: number
    cursor?: string
    direction: BannedKeywordPaginationDirectionType
    search?: string
  }
}

export const getBannedKeywordList = ({ params }: GetBannedKeywordListRequestType) =>
  Get<GetBannedKeywordListResponseType, true>({
    url: BANNED_KEYWORD_URL,
    params,
  })

export type BannedKeywordMutationResponseType = {
  data: {
    message: string
  }
}

export const postBannedKeyword = (keyword: string) =>
  Post<BannedKeywordMutationResponseType, true>({
    url: BANNED_KEYWORD_URL,
    data: { keyword },
  })

export const putBannedKeyword = ({ id, keyword }: Omit<BannedKeywordType, 'created_at'>) =>
  Put<BannedKeywordMutationResponseType, true>({
    url: `${BANNED_KEYWORD_URL}/${id}`,
    data: { keyword },
  })

export const deleteBannedKeyword = (id: string) =>
  Delete<BannedKeywordMutationResponseType, true>({
    url: `${BANNED_KEYWORD_URL}/${id}`,
  })
